(function ($) {
    $(function () {
        //make the whole teaser clickable
        if (!CONFIG.inExpEditor)
            $('.marktnews-teaser').on('click', function () { location.href = $(this).find('.marktnews-teaser__link').attr('href'); });
    });
})(jQuery);